module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm1_m.249ab5f9352f26927f02e07c92d06041.png";